<mp-filter-search-field
  class="filter-search-field"
  #searchField
  [searchFieldPlaceholder]="searchFieldPlaceholder()"
  [autocompleteControl]="autocompletePanel.matAutocomplete"
  (valueChange)="searchControl.setValue($event)"
/>

<mp-autocomplete-panel
  #autocompletePanel
  [options]="filteredBucketsOptions() | slice: 0 : 50"
  [optionTemplate]="optionTemplate.template"
  (valueSelected)="onBucketSelected($event)"
/>

<ng-template
  #optionTemplate="mpTypedTemplate"
  mpTypedTemplate
  [contextType]="autocompletePanel.optionTemplateContextType"
  let-option
>
  <mp-tree-facet-autocomplete-option [bucketOption]="option" />
</ng-template>
